<template lang="pug">
  .main
    top-bar
    v-container.grey.lighten-4.px-4(style="max-width: 500px;")
      h1.text-center.my-8.grey--text.text--darken-3 {{ $t('reset_your_password') }}
      p.text-center {{ $t('reset_your_password_desc') }}
      v-card(outlined).mt-4.pa-4
        v-card-text
          v-text-field(color="primary" v-model="form.password" type="password" label="New password" outlined @keyup.enter="submit")
          v-text-field(color="primary" v-model="confirmPassword" type="password" label="Confirm new password" outlined @keyup.enter="submit")
          v-btn.mb-4.font-weight-bold(color="accent" x-large block depressed @click="submit" :loading="loading") {{ $t('change_password') }}
</template>

<script>
  import TopBar from '@/components/TopBar.vue'
  import { mapActions } from 'vuex'

  export default {
    name: 'ResetPassword',
    components: { TopBar },
    props: ['email', 'code'],
    data: (vm) => ({
      loading: false,
      form: {
        email: vm.email,
        password: '',
        code: vm.code
      },
      confirmPassword: ''
    }),
    mounted () {
      if (!this.code) {
        this.$router.push('/signin')
      }
    },
    methods: {
      ...mapActions([
        'showMessage'
      ]),
      submit () {
        if (this.form.password != this.confirmPassword) {
          this.showMessage(['error', this.$t('error_message.password_not_match')])
          return
        }
        this.loading = true
        this.$axios.post('/users/reset_password/', this.form)
          .then(resp => {
            this.$store.commit('user/setUser', resp.data.user)
            this.$router.push('/companies')
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "reset_your_password": "Reset your password",
    "reset_your_password_desc": "Enter a new password for your Yezza account",
    "change_password": "Change password"
  },
  "id": {
    "reset_your_password": "Atur kata sandi",
    "reset_your_password_desc": "Masukkan kata sandi baru untuk akun Yezza kamu",
    "change_password": "Ubah kata sandi"
  }
}
</i18n>